// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"809eecb7","160":"c1291524","208":"f01bf322","293":"75c7cd6b","516":"476fc914","519":"29005a24","917":"b7d7d71d","946":"ef6b88cf"}[chunkId] + ".chunk.js";
};